export const OnlinePaymentDetailsPageTemplate = {
    slots: ['SlbOnlinePaymentHistoryDetailsSlot'],
}